<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>污染案例详情</template>

  <template #body>
    <div class="chart-body">
      <div v-if="model.formatData42.length > 0">
        <x-y-chart
          ref="chart"
          :data-config="data42Config"
          :unit-prop="unitProp"
          chart-type="line"
          :stack-type="1"
          download-name="4+2污染案例"
          chart-min-height="300px"
          chart-height="auto"
          selected-change-with-data-changed
          need-resize
        >
        </x-y-chart>
      </div>
      <div v-if="model.formatDataWind.length > 0">
        <dimension-weather-chart
          ref="windChart"
          :data-config="dataWindConfig"
          :dimension="0"
          :unit-prop="unitProp"
          download-name="气象污染案例"
          chart-min-height="300px"
        />
      </div>
      <div v-if="model.formatDataWind.length > 0 && model.formatData42.length > 0">
        <dimension-weather-chart
          ref="compreChart"
          :data-config="compreDataConfig"
          :dimension="0"
          :unit-prop="unitProp"
          download-name="污染案例"
          chart-min-height="300px"
        >
          <template #toolbar-after>
            <el-select v-model.trim="select42Id" size="small" style="width: 140px;" @change="selectChange">
              <el-option
                v-for="item in factor42"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              />
            </el-select>
          </template>
        </dimension-weather-chart>
      </div>
      <!-- <div class="gis-wapper">
        <div>gis动图</div>
      </div> -->
    </div>

    <el-form ref="form" :model="model">
      <el-form-item label="特征" prop="characteristicId" :rules="[{
          required: true,
          message: '请描述污染特征'
        }]"
      >
        <el-select v-model.trim="model.characteristicId" disabled style="width:100%;">
          <el-option
            v-for="item in characteristicList"
            :key="item.id"
            :value="item.id"
            :label="item.description"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../../../BaseEditor'
import XYChart from '../../../../../components/DataChart/XYChart'
import DimensionWeatherChart from '../../../../../components/Data/ChartWrapper/DimensionWeatherChart'

export default {
  name: 'Editor',
  extends: BaseEditor,
  components: {XYChart, DimensionWeatherChart},
  props: {
    unitProp: {
      type: String
    },
    windQuery: {
      type: Object
    },
    characteristicList: {
      type: Array
    }
  },
  data: () => ({
    model: {
      formatData42: {},
      formatDataWind: {}
    },
    test: [],
    testObj: {},
    select42Id: '',
    data42Config: {},
    dataWindConfig: {},
    compreDataConfig: {},
    data1: [],
    data2: [],
    data3: []
  }),
  computed: {
    factor42 () {
      let factorIds = ['1001', '1003', '1005', '1006', '1007', '1008']
      return factorIds.map(el => {
        return this.factorMap[el]
      })
    },
    query42 () {
      let factorIds = this.windQuery.factorIds
      return {
        ...this.windQuery,
        factorIds: factorIds.concat([this.select42Id])
      }
    }
  },
  methods: {
    initModel () {
      return {
        alias: null,
        factorId: null
      }
    },
    open (model) {
      this.onOpen(model)

      if (model) {
        this.model = {
          ...model,
          characteristicId: 1
        }
        let select42Id = this.factor42[0].id
        this.select42Id = select42Id
        if (model.formatData42.length > 0) {
          this.data42Config = Object.freeze(model.formatData42[0])
        }
        if (model.formatDataWind.length > 0) {
          this.dataWindConfig = Object.freeze(model.formatDataWind[0])
        }

        if (model.formatDataWind.length > 0 && model.formatData42.length > 0) {
          let dataObj = JSON.parse(JSON.stringify(model.formatDataWind[0]))
          let temp = {}
          temp[select42Id] = model.formatData42[0].seriesMap[select42Id] ? model.formatData42[0].seriesMap[select42Id] : {}
          if (model.formatData42[0].seriesMap[select42Id]) {
            dataObj.dataTimes = model.formatData42[0].dataTimes
          }
          dataObj.seriesMap = Object.assign(dataObj.seriesMap, temp)
          dataObj.dimensions = dataObj.dimensions.concat([{
            ...this.factorMap[select42Id],
            seriesParam: {
              type: 'line',
              showSymbol: false
            }
          }])

          this.compreDataConfig = Object.freeze(dataObj)
        }

        setTimeout(() => {
          let chart = this.$refs.chart
          chart.render()

          let windChart = this.$refs.windChart
          windChart.$refs.chart.render()

          let compreChart = this.$refs.compreChart
          compreChart.$refs.chart.render()
        }, 100)

        this.clearFormValid()
        this.opened = true
      }
    },
    selectChange () {
      let {model, select42Id} = this
      let dataObj = JSON.parse(JSON.stringify(this.model.formatDataWind[0]))
      let temp = {}
      temp[select42Id] = model.formatData42[0].seriesMap[select42Id] ? model.formatData42[0].seriesMap[select42Id] : {}
      if (model.formatData42[0].seriesMap[select42Id]) {
        dataObj.dataTimes = model.formatData42[0].dataTimes
      }
      dataObj.seriesMap = Object.assign(dataObj.seriesMap, temp)
      dataObj.dimensions = dataObj.dimensions.concat([{
        ...this.factorMap[select42Id],
        seriesParam: {
          type: 'line',
          showSymbol: false
        }
      }])

      this.compreDataConfig = Object.freeze(dataObj)
      setTimeout(() => {
        let compreChart = this.$refs.compreChart
        compreChart.$refs.chart.render()
      }, 100)
    },
    getDetail () {},
    save (callback, idKey) {
      let refForm = this.getForm()

      refForm && refForm.validate(flag => {
        if (!flag) {
          return
        }

        this.beforeSave()
        let model = {
          dataTime: this.model.dataTime,
          characteristicId: this.model.characteristicId,
          siteId: this.model.siteId,
          aqiGrade: this.model.aqiGrade,
          primaryPollutions: this.model.primaryPollutionsStr
        }

        this.changeLoadStatus(true)

        this.$api.Aqi.saveCase(model).then(data => {
          if (data) {
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success',
              position: 'bottom-right'
            })
            this.onSave(data)
            callback && callback(data)
          }
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .drawer-content-body {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto max-content;
}
.chart-body {
  width: 100%;
  height: 100%;
  overflow: auto;

  :last-child {
    margin-bottom: 0;
  }

  > div {
    margin-bottom: 10px;
    // height: 400px;
  }

  .gis-wapper {
    display: flex;
    justify-content: center;
    > div {
      width: 300px;
      height: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/11PollutionCases/02SelectPollutionCases/Editor.vue